import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientIPAddressService {
  private readonly IPIFY_URL = environment.production
    ? `https://api.ipify.org/?format=json`
    : `http://api.ipify.org/?format=json`;

  /** ipify is a third party that can take >1s; never let it hang the lookup. */
  private readonly FETCH_TIMEOUT_MS = 2500;

  private tempIp = '';

  constructor(private http: HttpClient) {
    // The IP is only used for audit logging, so defer this third-party call until the
    // browser is idle. Firing it from the constructor used to run during app bootstrap and
    // add ~1s to page-load (it showed up as a long task in APM). A delay — or even a total
    // failure — here is harmless.
    this.scheduleInit();
  }

  private scheduleInit() {
    const run = () => this.init();
    const idle = (window as any).requestIdleCallback;
    if (typeof idle === 'function') {
      idle(run, { timeout: 5000 });
    } else {
      setTimeout(run, 0);
    }
  }

  private init() {
    if (this.tempIp !== '') {
      return;
    }
    this.http
      .get(this.IPIFY_URL)
      .pipe(
        timeout(this.FETCH_TIMEOUT_MS),
        map((res: any) => res?.ip || ''),
        // ipify slow / blocked by firewall / down → stay empty instead of hanging.
        catchError(() => of(''))
      )
      .subscribe((ip: string) => {
        if (!ip) {
          return;
        }
        this.tempIp = ip;
      });
  }

  public get clientIp() {
    return this.tempIp || '';
  }
}
